import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import './Stats.css';

const stats = [
  { value: 2.4, suffix: ' GW', label: 'Installed Capacity', decimals: 1 },
  { value: 28, suffix: '+', label: 'Indian States Served' },
  { value: 3.8, suffix: 'M', label: 'Tons CO₂ Offset/yr', decimals: 1 },
  { value: 99.2, suffix: '%', label: 'Uptime Across Fleet', decimals: 1 },
];

function Counter({ to, decimals = 0, suffix = '', trigger }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    const start = performance.now();
    const duration = 1800;
    const raf = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(to * eased);
      if (p < 1) requestAnimationFrame(raf);
      else setN(to);
    };
    requestAnimationFrame(raf);
  }, [trigger, to]);
  return <span>{n.toFixed(decimals)}{suffix}</span>;
}

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  return (
    <section className="stats">
      <div className="container" ref={ref}>
        <motion.div
          className="stats-band glass"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="stats-label">
            <span className="eyebrow">India impact</span>
            <h3>Every sunrise, measurable progress.</h3>
          </div>
          <div className="stats-grid">
            {stats.map((s) => (
              <div className="stat" key={s.label}>
                <div className="stat-value">
                  <Counter to={s.value} decimals={s.decimals} suffix={s.suffix} trigger={inView} />
                </div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
